import { Resource } from './resource';
import { MultiPointInstallation } from './api';
import { OrganizationIdOrAll } from './all-organizations';

export type MultiPointInstallationDetail = {
  id: MultiPointInstallation['id'];
  name: string;
  height: string;
  sensors: Array<{
    serialNumber: string;
    spacingRight: string | null;
    doorwayName: string;
  }>;
  config: { [key: string]: any };

  // These are extracted out of the raw "config" value above and used as state to back the form
  //
  // Because these are numbers, it works a lot better when you have strings to
  // back the form fields.
  maxXOffsetMultiplier: string;
  spanMS: string;

  // Used as state to back the sensor reordering modal
  serialNumberPositions: Array<string>;
};

export type MultiPointInstallationEditState = {
  resource: Resource<MultiPointInstallationDetail>;
  saveButtonDisabled: boolean;
};

export enum MultiPointInstallationEditActionTypes {
  MULTI_POINT_INSTALLATION_EDIT_CHANGE_PAGE = 'MULTI_POINT_INSTALLATION_EDIT_CHANGE_PAGE',

  MULTI_POINT_INSTALLATION_EDIT_LOADING = 'MULTI_POINT_INSTALLATION_EDIT_LOADING',
  MULTI_POINT_INSTALLATION_EDIT_ERROR = 'MULTI_POINT_INSTALLATION_EDIT_ERROR',
  MULTI_POINT_INSTALLATION_EDIT_LOAD_COMPLETE = 'MULTI_POINT_INSTALLATION_EDIT_LOAD_COMPLETE',

  MULTI_POINT_INSTALLATION_EDIT_SET_NAME = 'MULTI_POINT_INSTALLATION_EDIT_SET_NAME',
  MULTI_POINT_INSTALLATION_EDIT_SET_HEIGHT = 'MULTI_POINT_INSTALLATION_EDIT_SET_HEIGHT',
  MULTI_POINT_INSTALLATION_EDIT_SET_SPAN_MS = 'MULTI_POINT_INSTALLATION_EDIT_SET_SPAN_MS',
  MULTI_POINT_INSTALLATION_EDIT_SET_MAX_X_OFFSET_MULTIPLIER = 'MULTI_POINT_INSTALLATION_EDIT_SET_MAX_X_OFFSET_MULTIPLIER',

  MULTI_POINT_INSTALLATION_EDIT_SET_SPACING_RIGHT = 'MULTI_POINT_INSTALLATION_EDIT_SET_SPACING_RIGHT',
  MULTI_POINT_INSTALLATION_EDIT_SET_SENSOR_ORDER = 'MULTI_POINT_INSTALLATION_EDIT_SET_SENSOR_ORDER',
  MULTI_POINT_INSTALLATION_EDIT_REMOVE_SENSOR = 'MULTI_POINT_INSTALLATION_EDIT_REMOVE_SENSOR',
  MULTI_POINT_INSTALLATION_EDIT_ADD_SENSORS = 'MULTI_POINT_INSTALLATION_EDIT_ADD_SENSORS',

  MULTI_POINT_INSTALLATION_EDIT_SUBMIT = 'MULTI_POINT_INSTALLATION_EDIT_SUBMIT',
  MULTI_POINT_INSTALLATION_EDIT_DELETE = 'MULTI_POINT_INSTALLATION_EDIT_DELETE',
}

export type MultiPointInstallationEditAction =
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_CHANGE_PAGE;
      id: MultiPointInstallation['id'];
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_LOADING;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_ERROR;
      error: any;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_LOAD_COMPLETE;
      item: MultiPointInstallation;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_SET_NAME;
      name: string;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_SET_HEIGHT;
      height: string;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_SET_SPAN_MS;
      spanMS: string;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_SET_MAX_X_OFFSET_MULTIPLIER;
      maxXOffsetMultiplier: string;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_SET_SPACING_RIGHT;
      serialNumber: string;
      spacingRight: string;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_SUBMIT;
      organizationIdOrAll: OrganizationIdOrAll;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_REMOVE_SENSOR;
      serialNumber: string;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_ADD_SENSORS;
      sensors: Array<{ serialNumber: string; doorwayName: string }>;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_SET_SENSOR_ORDER;
      serialNumbers: Array<string>;
    }
  | {
      type: MultiPointInstallationEditActionTypes.MULTI_POINT_INSTALLATION_EDIT_DELETE;
      organizationIdOrAll: OrganizationIdOrAll;
    };
